import { render, staticRenderFns } from "./PlotResults.vue?vue&type=template&id=06e4039d&scoped=true"
import script from "./PlotResults.vue?vue&type=script&lang=js"
export * from "./PlotResults.vue?vue&type=script&lang=js"
import style0 from "./PlotResults.vue?vue&type=style&index=0&id=06e4039d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e4039d",
  null
  
)

export default component.exports